// components/ProductCarousel.js
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { Link } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const catMeta = {
  Tablets:    { icon: 'ti-pill',    bar: 'linear-gradient(90deg,#1D9E75,#5DCAA5)', iconBg: '#E1F5EE', iconColor: '#0F6E56', catBg: '#E1F5EE', catColor: '#085041' },
  Injections: { icon: 'ti-needle',  bar: 'linear-gradient(90deg,#185FA5,#378ADD)', iconBg: '#E6F1FB', iconColor: '#185FA5', catBg: '#E6F1FB', catColor: '#0C447C' },
  Syrups:     { icon: 'ti-bottle',  bar: 'linear-gradient(90deg,#7F77DD,#AFA9EC)', iconBg: '#EEEDFE', iconColor: '#534AB7', catBg: '#EEEDFE', catColor: '#3C3489' },
  Ointments:  { icon: 'ti-bandage', bar: 'linear-gradient(90deg,#BA7517,#EF9F27)', iconBg: '#FAEEDA', iconColor: '#854F0B', catBg: '#FAEEDA', catColor: '#633806' },
};

const products = [
  { id: 1, name: 'Paracetamol 500mg', cat: 'Tablets',    desc: 'Pain relief & fever reducer'         },
  { id: 2, name: 'Amoxicillin 250mg', cat: 'Tablets',    desc: 'Antibiotic for bacterial infections'  },
  { id: 3, name: 'Insulin Injection', cat: 'Injections', desc: 'Diabetes management'                  },
  { id: 4, name: 'Cough Syrup',       cat: 'Syrups',     desc: 'Relieves cough & throat irritation'   },
  { id: 5, name: 'Antiseptic Cream',  cat: 'Ointments',  desc: 'Prevents infection in minor cuts'     },
  { id: 6, name: 'Vitamin C Tablets', cat: 'Tablets',    desc: 'Immunity booster'                     },
  { id: 7, name: 'Diclofenac Gel',    cat: 'Ointments',  desc: 'Joint & muscle pain relief'           },
  { id: 8, name: 'Cetirizine',        cat: 'Tablets',    desc: 'Antihistamine for allergies'          },
];

const ProductCard = ({ product }) => {
  const [hovered, setHovered] = useState(false);
  const m = catMeta[product.cat];

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: '#fff',
        border: `1px solid ${hovered ? 'rgba(29,158,117,.35)' : '#E1F5EE'}`,
        borderRadius: 16, overflow: 'hidden',
        display: 'flex', flexDirection: 'column',
        transform: hovered ? 'translateY(-6px)' : 'none',
        boxShadow: hovered ? '0 20px 48px rgba(15,110,86,.13)' : 'none',
        transition: 'transform .22s, box-shadow .22s, border-color .22s',
        height: '100%',
      }}
    >
      <div style={{ height: 4, background: m.bar }} />
      <div style={{ padding: '1.35rem 1.1rem', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', flex: 1, gap: 8 }}>
        <div style={{ width: 62, height: 62, borderRadius: '50%', background: m.iconBg, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 4 }}>
          <i className={`ti ${m.icon}`} style={{ fontSize: 28, color: m.iconColor }} aria-hidden="true" />
        </div>
        <span style={{ fontSize: 10.5, fontWeight: 700, letterSpacing: '.08em', textTransform: 'uppercase', padding: '3px 10px', borderRadius: 100, background: m.catBg, color: m.catColor }}>
          {product.cat}
        </span>
        <p style={{ fontFamily: "'Outfit',sans-serif", fontSize: 14.5, fontWeight: 700, color: '#085041', lineHeight: 1.25 }}>{product.name}</p>
        <p style={{ fontSize: 12, color: '#0F6E56', opacity: .7, lineHeight: 1.5 }}>{product.desc}</p>
        <Link to="/contact" style={{
          marginTop: 'auto',
          display: 'inline-flex', alignItems: 'center', gap: 5,
          fontSize: 12.5, fontWeight: 700, letterSpacing: '.02em',
          color: hovered ? '#e6f0edff' : '#0F6E56',
          padding: '7px 16px', borderRadius: 8,
          border: `1.5px solid ${hovered ? '#085041' : 'rgba(29,158,117,.3)'}`,
          background: hovered ? '#085041' : 'rgba(29,158,117,.06)',
          textDecoration: 'none', transition: 'all .18s',
        }}>
          Inquiry <i className="ti ti-arrow-right" style={{ fontSize: 14 }} aria-hidden="true" />
        </Link>
      </div>
    </div>
  );
};

const ProductCarousel = () => (
  <section style={{ padding: '3.5rem 1.25rem', background: '#fff', fontFamily: "'Barlow',sans-serif" }}>

    {/* Header */}
    <div style={{ textAlign: 'center', marginBottom: '2.75rem' }}>
      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 7, background: '#085041', color: '#9FE1CB', fontSize: 11, fontWeight: 700, letterSpacing: '.12em', textTransform: 'uppercase', padding: '5px 16px', borderRadius: 100, marginBottom: '1rem' }}>
        <i className="ti ti-rosette" aria-hidden="true" /> Premium Range
      </div>
      <h2 style={{ fontFamily: "'Outfit',sans-serif", fontSize: '2.2rem', fontWeight: 800, color: '#085041', letterSpacing: '-.5px', lineHeight: 1.1, marginBottom: '.5rem' }}>
        Our <span style={{ color: '#1D9E75' }}>Top Products</span>
      </h2>
      <div style={{ width: 52, height: 3, background: 'linear-gradient(90deg,#1D9E75,#185FA5)', borderRadius: 2, margin: '.6rem auto .9rem' }} />
      <p style={{ fontSize: 14, color: '#0F6E56', opacity: .75, maxWidth: 420, margin: '0 auto', lineHeight: 1.6 }}>
        Explore our wide range of high-quality pharmaceutical products sourced from certified manufacturers
      </p>
    </div>

    {/* Swiper */}
    <Swiper
      modules={[Autoplay, Pagination, Navigation]}
      spaceBetween={18}
      slidesPerView={1}
      pagination={{ clickable: true }}
      navigation={{
        prevEl: '.swiper-btn-prev',
        nextEl: '.swiper-btn-next',
      }}
      autoplay={{ delay: 3000, disableOnInteraction: false, pauseOnMouseEnter: true }}
      breakpoints={{
        400: { slidesPerView: 2 },
        640: { slidesPerView: 3 },
        900: { slidesPerView: 4 },
      }}
      style={{ paddingBottom: '2.5rem' }}
    >
      {products.map(p => (
        <SwiperSlide key={p.id} style={{ height: 'auto' }}>
          <ProductCard product={p} />
        </SwiperSlide>
      ))}

      {/* Custom nav buttons */}
      <div slot="container-start">
        <button className="swiper-btn-prev" style={navBtnStyle('left')}>
          <i className="ti ti-chevron-left" style={{ fontSize: 18, color: '#9FE1CB' }} aria-hidden="true" />
        </button>
        <button className="swiper-btn-next" style={navBtnStyle('right')}>
          <i className="ti ti-chevron-right" style={{ fontSize: 18, color: '#9FE1CB' }} aria-hidden="true" />
        </button>
      </div>
    </Swiper>

    {/* View All */}
    <div style={{ textAlign: 'center', marginTop: '1rem' }}>
      <Link to="/products" style={{
        display: 'inline-flex', alignItems: 'center', gap: 8,
        background: '#085041', color: '#9FE1CB',
        fontSize: 13, fontWeight: 700, letterSpacing: '.04em',
        padding: '11px 26px', borderRadius: 10, textDecoration: 'none',
      }}>
        <i className="ti ti-eye" style={{ fontSize: 17 }} aria-hidden="true" /> View All Products
      </Link>
    </div>
  </section>
);

const navBtnStyle = (side) => ({
  position: 'absolute',
  [side]: -6, top: '42%', transform: 'translateY(-50%)',
  zIndex: 10, width: 38, height: 38, borderRadius: '50%',
  background: '#085041', border: 'none', cursor: 'pointer',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
});

export default ProductCarousel;